import InvitationListView from "../../components/InvitationListView";

import { InvitationMode } from "../../__generated__/graphql";
import { InvitationFieldsFragment } from "../../__generated__/operations/graphql";
import type { Meta, StoryObj } from "@storybook/react";
import { action } from "storybook/actions";

const meta = {
    title: "Views/Invitation list",
    component: InvitationListView,
    argTypes: {},
    args: {
        invitations: [
            {
                id: "invitation-1",
                senderName: "Monsieur One",
                clientName: "La compagnie du premier",
                clientLogoUrl: "https://picsum.photos/200",
                firstName: "Jean",
                lastName: "Dupont",
                createdAt: "2021-01-01T12:00:00Z",
                phoneNumber: "+41799999901",
                email: null,
                token: "token-1",
                text: "Bonjour, je vous invite à rejoindre ma compagnie.",
                mode: InvitationMode.Receiver,
                clientFormattedAddress: null,
                target: null,
            },
            {
                id: "invitation-2",
                senderName: "Monsieur AvecUnTresLongNom DifficileAWrapper",
                clientName: "La compagnie du second",
                clientLogoUrl: "https://picsum.photos/200",
                firstName: "Pierre",
                lastName: "Quiroule",
                createdAt: "2021-01-01T12:00:00Z",
                phoneNumber: "+41799999902",
                email: null,
                token: "token-1",
                mode: InvitationMode.Receiver,
                text: null,
                clientFormattedAddress: null,
                target: null,
            },
            {
                id: "invitation-3",
                senderName: "Monsieur Trois",
                clientName: "La compagnie du troisième",
                clientLogoUrl: "https://picsum.photos/200",
                firstName: "Paul",
                lastName: "Prevost",
                createdAt: "2021-01-03T12:00:00Z",
                phoneNumber: "+41799999903",
                email: null,
                token: "token-1",
                text: "Allez, bouges toi et viens !",
                mode: InvitationMode.Receiver,
                clientFormattedAddress: null,
                target: null,
            },
            {
                id: "invitation-4",
                clientName: "La compagnie du troisième",
                clientLogoUrl: "https://picsum.photos/200",
                firstName: "Paul",
                lastName: "Prevost",
                createdAt: "2021-01-03T12:00:00Z",
                // Sent by email from the web app: no phone number.
                phoneNumber: null,
                email: "paul.prevost@example.com",
                token: "token-2",
                text: "Allez, bouges toi et viens !",
                mode: InvitationMode.Sender,
                senderName: "Monsieur Trois",
                clientFormattedAddress: null,
                target: null,
            },
        ],
    },
} satisfies Meta<typeof InvitationListView>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {
    args: {
        onSelectInvitation: (invitation: InvitationFieldsFragment) => {
            action(`Invitation selected: ${invitation.id}`);
        },
    },
};

export const ReadOnly: Story = {
    args: {},
};
